import script from "./ConfirmPasswordReset.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmPasswordReset.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmPasswordReset.vue?vue&type=style&index=0&id=278107ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-278107ea"]])

export default __exports__